/* EMPLOYEES */
export const GET_EMPLOYEES = "GET_EMPLOYEES"
export const GET_EMPLOYEES_SUCCESS = "GET_EMPLOYEES_SUCCESS"
export const GET_EMPLOYEES_FAIL = "GET_EMPLOYEES_FAIL"


/* GET_EMPLOYEE_DETAIL */
export const GET_EMPLOYEE_DETAIL = "GET_EMPLOYEE_DETAIL"
export const GET_EMPLOYEE_DETAIL_SUCCESS = "GET_EMPLOYEE_DETAIL_SUCCESS"
export const GET_EMPLOYEE_DETAIL_FAIL = "GET_EMPLOYEE_DETAIL_FAIL"

/*  */
export const GET_AUTH_USER = "GET_AUTH_USER"
export const GET_AUTH_USER_FAIL = "GET_AUTH_USER_FAIL"
export const GET_AUTH_USER_SUCCESS = "GET_AUTH_USER_SUCCESS"

/**
 * add EMPLOYEE
 */
 export const ADD_NEW_EMPLOYEE = "ADD_NEW_EMPLOYEE"
 export const ADD_EMPLOYEE_SUCCESS = "ADD_EMPLOYEE_SUCCESS"
 export const ADD_EMPLOYEE_FAIL = "ADD_EMPLOYEE_FAIL"
 
 /**
  * Edit EMPLOYEE
  */
 export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE"
 export const UPDATE_EMPLOYEE_SUCCESS = "UPDATE_EMPLOYEE_SUCCESS"
 export const UPDATE_EMPLOYEE_FAIL = "UPDATE_EMPLOYEE_FAIL"
 
 /**
  * Delete EMPLOYEE
  */
 export const DELETE_EMPLOYEE = "DELETE_EMPLOYEE"
 export const DELETE_EMPLOYEE_SUCCESS = "DELETE_EMPLOYEE_SUCCESS"
 export const DELETE_EMPLOYEE_FAIL = "DELETE_EMPLOYEE_FAIL"
 

